const MONTHS = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Collapse a city's bestMonths into readable ranges, e.g. [4,5,6,9,10] → "Apr–Jun, Sep–Oct".
export function monthRanges(months) {
  const ms = [...new Set((months || []).filter((m) => m >= 1 && m <= 12))].sort((a, b) => a - b);
  if (!ms.length) return null;
  const out = [];
  let start = ms[0]; let prev = ms[0];
  for (const m of ms.slice(1).concat(null)) {
    if (m === prev + 1) { prev = m; continue; }
    out.push(start === prev ? MONTHS[start] : `${MONTHS[start]}–${MONTHS[prev]}`);
    start = m; prev = m;
  }
  return out.join(', ');
}

const validMonths = (months) => [...new Set((months || []).filter((m) => m >= 1 && m <= 12))].sort((a, b) => a - b);

export function isYearRound(months) {
  return validMonths(months).length === 12;
}

// With this many comfortable months, naming the missing ones reads better than listing ranges.
const MOST_OF_YEAR = 9;

const exceptMonths = (ms) => monthRanges([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].filter((m) => !ms.includes(m)));

// Short label for the hero chip, e.g. "Year-round", "All year except Nov", "Apr–Jun, Sep–Oct".
export function bestMonthsLabel(months) {
  const ms = validMonths(months);
  if (!ms.length) return null;
  if (ms.length === 12) return 'Year-round';
  if (ms.length >= MOST_OF_YEAR) return `All year except ${exceptMonths(ms)}`;
  return monthRanges(ms);
}

export const YEAR_ROUND_TEXT = 'Comfortable to visit year-round, based on 30-year climate normals.';

export function bestMonthsSentence(months) {
  const ms = validMonths(months);
  if (!ms.length) return null;
  if (ms.length === 12) return YEAR_ROUND_TEXT;
  if (ms.length >= MOST_OF_YEAR) return `Comfortable to visit most of the year (all except ${exceptMonths(ms)}), based on 30-year climate normals.`;
  return `The most comfortable months to visit are ${monthRanges(ms)}, based on 30-year climate normals.`;
}

// Stored whenToVisit text spells out every comfortable month ("January, February, …");
// swap that sentence for the concise one. Its "Outside these months…" follow-up is dropped for
// year-round cities and names the excluded months for most-of-the-year ones.
const MONTH_LIST_SENTENCE = /The most comfortable months to visit are[^.]*\./;
const OUTSIDE_SENTENCE = /\s*Outside these months[^.]*\./;
export function conciseWhenToVisit(text, months) {
  const sentence = bestMonthsSentence(months);
  if (typeof text !== 'string' || !sentence || !MONTH_LIST_SENTENCE.test(text)) return text;
  const ms = validMonths(months);
  const out = text.replace(MONTH_LIST_SENTENCE, sentence);
  if (ms.length === 12) return out.replace(OUTSIDE_SENTENCE, '');
  if (ms.length >= MOST_OF_YEAR) return out.replace(/Outside these months/, `In ${exceptMonths(ms)}`);
  return out;
}
